import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LanguageContext";

// Rabais de bienvenue AUTOMATIQUE (demande du propriétaire, 2026-10-23) : le client
// abonné à l'infolettre qui passe sa PREMIÈRE commande voit WELCOME10 appliqué tout
// seul au panier et à la caisse — sans avoir à taper le code. Un seul essai par
// visite ; silencieux si non admissible (ou hors ligne).
export function AutoPromoBienvenue() {
  const { user } = useAuth();
  const { promo, applyPromo } = useCart();
  const { t } = useLang();
  const tente = useRef(false);
  useEffect(() => {
    if (!user || promo || tente.current) return;
    tente.current = true;
    api.get("/promo/auto").then(({ data }) => {
      if (data?.code) {
        applyPromo(data);
        toast.success(t("promo.auto", { code: data.code }));
      }
    }).catch(() => {});
  }, [user, promo, applyPromo, t]);
  return null;
}
